<template>
  <FlipCard
    title="Consequence"
    color="white"
    font="primary"
    icon="fa-solid fa-exclamation"
    iconColor="primary"
    :value="flipped"
    @click.stop="click"
  >
    <template v-slot:front>
      <BigNumber
        v-if="assignedValue"
        title=""
        :subtitle="value.scale"
        :value="value.value"
        valueFont="display-4 primary--text"
        subtitleFont="subtitle-2 primary--text"
        @click="click"
      >
      </BigNumber>
      <v-icon center v-else size="90" color="primary">fa-solid fa-empty-set</v-icon>
      <div v-if="(!assignedValue || showFailureMode) && assignedFailureModeValue" class="pt-4 subtitle-2 primary--text">
        Failure Mode Consequence: ${{
          parseInt(
            failureModeConsequence !== null && failureModeConsequence !== undefined && !isNaN(failureModeConsequence)
              ? failureModeConsequence
              : 0
          ).toLocaleString()
        }}
      </div>
    </template>
    <template v-slot:frontAction>
      <v-btn v-if="!readonly && !assignedValue" icon>
        <v-icon color="secondary">fa-plus</v-icon>
      </v-btn>
    </template>
    <template v-slot:back>
      <v-form
        class="pt-0"
        ref="form"
        :readonly="readonly"
        @click.native.stop
        @mousedown.native.stop
        @keydown.native.stop
      >
        <v-row dense no-gutters>
          <v-col cols="12">
            <FormattedNumberField
              label="Cost of failure"
              :value="value.value"
              @input="valueInput"
              :rules="assignedValue ? [rules.isInteger, rules.required, rules.isPositive] : []"
              hide-details="auto"
              prepend-icon="fa-solid fa-exclamation"
              :suffix="value.scale"
              :readonly="readonly"
            >
              <template v-slot:prepend>
                <v-icon class="prepend-icon" small color="primary">fa-solid fa-exclamation</v-icon>
              </template>
            </FormattedNumberField>
          </v-col>
          <v-col cols="12" v-if="!hideDescription">
            <v-textarea
              label="Description"
              :value="value.description"
              @input="descriptionInput"
              rows="1"
              hide-details="auto"
              :readonly="readonly"
            >
              <template v-slot:prepend>
                <v-icon class="prepend-icon" small color="primary">fa-solid fa-align-left</v-icon>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:backAction v-if="!readonly">
      <v-btn v-if="assignedValue" icon @click.stop="remove">
        <v-icon color="primary">fa-trash-can</v-icon>
      </v-btn>
    </template>
  </FlipCard>
</template>
<script>
import { BigNumber, FlipCard, FormattedNumberField, Rules } from '@itus/ui.common'
import { ConsequenceModel, consequenceLifeCycleState } from './consequence-model'

export default {
  name: 'ConsequenceCard',
  props: {
    value: {
      type: Object,
      description: 'ConsequenceModel object'
    },
    failureModeConsequence: {
      type: Number,
      description: 'Falure Mode driving consequence.'
    },
    readonly: Boolean,
    hideDescription: Boolean,
    showFailureMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultConsequenceScale: 'dollars',
      rules: Rules,
      flipped: false
    }
  },
  components: {
    FlipCard,
    BigNumber,
    FormattedNumberField
  },
  computed: {
    assignedValue() {
      return (
        this.value &&
        this.value.lifeCycleState !== consequenceLifeCycleState.notDefined &&
        this.value.lifeCycleState !== consequenceLifeCycleState.removed
      )
    },
    assignedFailureModeValue() {
      return this.failureModeConsequence !== null && this.failureModeConsequence !== undefined
    }
  },
  methods: {
    click() {
      if (this.flipped && this.assignedValue && !this.$refs.form.validate()) {
        return
      }
      if (!this.flipped) {
        this.$refs.form.resetValidation()
      }
      this.$nextTick(() => (this.flipped = !this.flipped))
    },
    valueInput(newValue) {
      let newData = Object.assign({}, this.value)
      newData.value = newValue
      this.setLifeCycleState(newData)

      let newConsequence = new ConsequenceModel(newData)
      this.$emit('input', newConsequence)
    },
    descriptionInput(newDescription) {
      let newData = Object.assign({}, this.value)
      newData.description = newDescription
      this.setLifeCycleState(newData)

      let newValue = new ConsequenceModel(newData)
      this.$emit('input', newValue)
    },
    setLifeCycleState(newValue) {
      if (!newValue.lifeCycleState) {
        return
      }
      if (newValue.lifeCycleState === consequenceLifeCycleState.notDefined) {
        newValue.lifeCycleState = consequenceLifeCycleState.new
      } else if (newValue.lifeCycleState === consequenceLifeCycleState.removed) {
        newValue.lifeCycleState = consequenceLifeCycleState.edit
      }
    },
    async remove() {
      this.flipped = false
      let newLifeCycleState = null
      if (this.value.lifeCycleState === consequenceLifeCycleState.new) {
        newLifeCycleState = consequenceLifeCycleState.notDefined
      } else if (!this.value.lifeCycleState) {
        newLifeCycleState = consequenceLifeCycleState.removed
      }

      let removedConsequence = new ConsequenceModel({
        id: this.value.id,
        assetId: this.value.assetId,
        twinId: this.value.twinId,
        failureModeId: this.value.failureModeId,
        lifeCycleState: newLifeCycleState
      })
      this.$emit('input', removedConsequence)
    },
    validate() {
      if (!this.assignedValue) {
        return true
      }
      return this.$refs.form.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.prepend-icon {
  min-width: 20px;
}
</style>
